var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"chart",attrs:{"height":"300","width":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }